import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["visible", "duration", "as"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { backgroundColor, opacity, zIndex, position } from 'styled-system';
import styled, { css } from 'styled-components';
import { Fade, rotate } from '../animations';
import Box from '../Box';
import { useThemeDefaults } from '../utils';
var SpinnerIcon = useThemeDefaults(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color;
  return {
    iconColor: theme.colors[color] ? theme.colors[color] : color
  };
}, styled(Box).withConfig({
  displayName: "Spinner__SpinnerIcon",
  componentId: "sc-1j6ptb9-0"
})(["border-radius:50%;box-sizing:border-box;display:inline-block;vertical-align:middle;width:", ";height:", ";border:", ";border-color:", ";animation:", ";"], function (props) {
  return "".concat(props.size, "px");
}, function (props) {
  return "".concat(props.size, "px");
}, function (props) {
  return "".concat(props.size / 10, "px solid ").concat(props.iconColor);
}, function (props) {
  return "".concat(props.iconColor, "  ").concat(props.iconColor, "  ").concat(props.iconColor, " transparent");
}, function (props) {
  return css(["", " ", "s linear infinite"], rotate, props.spinnerSpeed / 1000);
}));
var SpinnerBackdrop = styled(Box).withConfig({
  displayName: "Spinner__SpinnerBackdrop",
  componentId: "sc-1j6ptb9-1"
})({
  position: 'absolute',
  width: '100%',
  left: '0',
  top: '0',
  height: '100%'
}, backgroundColor, opacity);
SpinnerBackdrop.propTypes = {
  visible: PropTypes.bool
};
var SpinnerLayout = styled(Box).withConfig({
  displayName: "Spinner__SpinnerLayout",
  componentId: "sc-1j6ptb9-2"
})({
  position: 'absolute',
  width: '100%',
  left: '0',
  top: '0',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}, zIndex, position);

var getSpinnerDefaults = function getSpinnerDefaults(props) {
  return {
    bg: props.theme.colors[props.theme.spinner.bg],
    opacity: props.theme.spinner.opacity,
    size: props.theme.spinner.size,
    zIndex: props.theme.spinner.zIndex,
    duration: props.theme.spinner.appearanceSpeed,
    spinnerSpeed: props.theme.spinner.spinnerSpeed,
    color: props.theme.colors[props.theme.spinner.color]
  };
};

var getInlineDefaults = function getInlineDefaults(props) {
  return _objectSpread(_objectSpread({}, getSpinnerDefaults(props)), {}, {
    bg: props.theme.colors[props.theme.spinner.inlineBg],
    size: props.theme.spinner.inlineSize
  });
};

export var Spinner = useThemeDefaults(getSpinnerDefaults, function (_ref2) {
  var visible = _ref2.visible,
      size = _ref2.size,
      bg = _ref2.bg,
      color = _ref2.color,
      opacity = _ref2.opacity,
      zIndex = _ref2.zIndex,
      spinnerSpeed = _ref2.spinnerSpeed,
      duration = _ref2.duration,
      className = _ref2.className,
      position = _ref2.position;
  return /*#__PURE__*/React.createElement(Fade, {
    visible: visible,
    duration: duration,
    className: className
  }, /*#__PURE__*/React.createElement(SpinnerLayout, {
    zIndex: zIndex,
    position: position
  }, /*#__PURE__*/React.createElement(SpinnerBackdrop, {
    bg: bg,
    opacity: opacity
  }), /*#__PURE__*/React.createElement(SpinnerIcon, {
    size: size,
    color: color,
    spinnerSpeed: spinnerSpeed,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100
  })));
});
export var InlineSpinner = useThemeDefaults(getInlineDefaults, function (_ref3) {
  var visible = _ref3.visible,
      duration = _ref3.duration,
      _ref3$as = _ref3.as,
      as = _ref3$as === void 0 ? 'span' : _ref3$as,
      props = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(Fade, {
    duration: duration,
    display: "inline-block",
    as: as,
    visible: visible
  }, /*#__PURE__*/React.createElement(SpinnerIcon, _extends({
    duration: duration,
    as: as,
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100
  }, props)));
});